import { z } from 'zod';
import { ErrorCode } from '../errors.js';

export const UuidSchema = z.uuid();
export const SlugSchema = z
  .string()
  .min(1)
  .max(80)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Use lowercase letters, numbers and hyphens');

export const ErrorEnvelopeSchema = z.object({
  error: z.object({
    code: z.enum(Object.values(ErrorCode) as [string, ...string[]]),
    message: z.string(),
    status: z.number().int(),
    details: z.unknown().optional(),
    hint: z.string().optional(),
    requestId: z.string().optional(),
  }),
});
export type ErrorEnvelope = z.infer<typeof ErrorEnvelopeSchema>;

export const PaginationQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(25),
  cursor: z.string().max(200).optional(),
});

export const OffsetPaginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(25),
  sort: z.string().max(60).optional(),
  order: z.enum(['asc', 'desc']).default('desc'),
  q: z.string().max(200).optional(),
});

export const listResponse = <T extends z.ZodType>(item: T) =>
  z.object({
    items: z.array(item),
    total: z.number().int().nonnegative().optional(),
    nextCursor: z.string().nullable().optional(),
  });

export const OkSchema = z.object({ ok: z.literal(true) });

/** ISO datetime string used across all response schemas (never z.date()). */
export const DateTimeSchema = z.iso.datetime({ offset: true });
export const NullableDateTimeSchema = DateTimeSchema.nullable();
